"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _antd = require("antd");

var _immer = _interopRequireDefault(require("immer"));

var _icons = require("@ant-design/icons");

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _Caption = _interopRequireDefault(require("../Caption"));

var _Fields = require("../editor/Fields");

var _theme = require("../../theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var FlexibleContent = function FlexibleContent(props) {
  var id = props.id,
      label = props.label,
      instructions = props.instructions,
      items = props.items,
      value = props.value,
      onChange = props.onChange,
      level = props.level;
  var values = value || [];

  var _ref3 = (0, _react.useState)([]),
      _ref4 = _slicedToArray(_ref3, 2),
      childActive = _ref4[0],
      setChildActive = _ref4[1];

  var handleAdd = function handleAdd(id) {
    if (items) {
      var layout = items.find(function (o) {
        return o.id === id;
      });
      var newValues = (0, _immer.default)(values, function (draft) {
        draft.push(_objectSpread({
          id: id
        }, layout.fields.reduce(function (ac, a) {
          return _objectSpread(_objectSpread({}, ac), {}, _defineProperty({}, a.id, a.defaultValue || ''));
        }, {})));
        return draft;
      });
      onChange(newValues);
      handleToggleChild(values.length);
    }
  };

  var handleRemove = function handleRemove(index) {
    var newValues = (0, _immer.default)(values, function (draft) {
      draft.splice(index, 1);
      return draft;
    });
    onChange(newValues);
  };

  var handleChange = function handleChange(item, index) {
    var newValues = (0, _immer.default)(values, function (draft) {
      draft[index][item.id] = item.value;
      return draft;
    });
    onChange(newValues);
  };

  var handleToggleChild = function handleToggleChild(key) {
    var newKeys = (0, _immer.default)(childActive, function (draft) {
      if (childActive.includes(key)) {
        draft = draft.filter(function (k) {
          return k !== key;
        });
      } else {
        draft.push(key);
      }

      return draft;
    });
    setChildActive(newKeys);
  };

  var menuItems = items.map(function (o) {
    return /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
      key: o.id,
      children: o.label,
      onClick: function onClick() {
        return handleAdd(o.id);
      }
    });
  });

  var menu = /*#__PURE__*/_react.default.createElement(_antd.Menu, null, menuItems);

  var getListStyle = function getListStyle(isDraggingOver) {
    return {
      background: isDraggingOver ? _theme.colors.tertiary : 'transparent'
    };
  };

  var getItemStyle = function getItemStyle(isDragging, draggableStyle) {
    return _objectSpread({
      userSelect: 'none',
      padding: '1px 0'
    }, draggableStyle);
  };

  var handleDragEnd = function handleDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    var index = result.source.index;
    var newIndex = result.destination.index;
    var newValues = (0, _immer.default)(values, function (draft) {
      if (newIndex > -1 && newIndex < draft.length) {
        var temp = draft[index];
        draft[index] = draft[newIndex];
        draft[newIndex] = temp;
      }

      return draft;
    });
    onChange(newValues);
  };

  return /*#__PURE__*/_react.default.createElement(Container, {
    level: level
  }, /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: label || id
  }), instructions && /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: "secondary",
    children: instructions
  }), values && /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, provided.droppableProps, {
      ref: provided.innerRef,
      style: getListStyle(snapshot.isDraggingOver)
    }), values.map(function (value, index) {
      var layout = items.find(function (o) {
        return o.id === value.id;
      });
      return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: index,
        draggableId: "item-".concat(index),
        index: index,
        isDragDisabled: childActive.includes(index)
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps, {
          style: getItemStyle(snapshot.isDragging, provided.draggableProps.style)
        }), /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
          activeKey: childActive,
          onChange: function onChange() {
            return handleToggleChild(index);
          },
          expandIconPosition: "right"
        }, /*#__PURE__*/_react.default.createElement(_antd.Collapse.Panel, {
          key: index,
          header: (layout === null || layout === void 0 ? void 0 : layout.label) || 'Not Found',
          extra: /*#__PURE__*/_react.default.createElement(DeleteIcon, {
            className: "icon",
            onClick: function onClick(e) {
              return e.stopPropagation();
            }
          }, /*#__PURE__*/_react.default.createElement(DeleteIconContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
            title: "Are you sure\uFF1F",
            onConfirm: function onConfirm() {
              return handleRemove(index);
            },
            icon: /*#__PURE__*/_react.default.createElement(_icons.QuestionCircleOutlined, {
              style: {
                color: _theme.colors.danger
              }
            }),
            placement: "left"
          }, /*#__PURE__*/_react.default.createElement(_icons.DeleteTwoTone, {
            twoToneColor: _theme.colors.danger
          }))))
        }, (layout === null || layout === void 0 ? void 0 : layout.fields) && layout.fields.map(function (field, fieldIndex) {
          return /*#__PURE__*/_react.default.createElement("div", {
            key: field.id
          }, (0, _Fields.getField)({
            field: _objectSpread(_objectSpread({}, field), {}, {
              value: value === null || value === void 0 ? void 0 : value[field.id]
            }),
            index: index,
            onChangeElement: function onChangeElement(value) {
              return handleChange(value, index);
            }
          }));
        }))));
      });
    }), provided.placeholder);
  })), /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
    overlay: menu,
    trigger: ['click'],
    getPopupContainer: function getPopupContainer(triggerNode) {
      return triggerNode.parentNode;
    }
  }, /*#__PURE__*/_react.default.createElement(AddButton, {
    siblings: values && values.length > 0
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusOutlined, null)))));
};

var Container = (0, _styledComponents.default)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding: 12px ", ";\n"])), function (_ref) {
  var level = _ref.level;
  return level === 0 ? '16px' : '10px';
});

var DeleteIconContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  opacity: ", ";\n"])), function (props) {
  return props.disabled ? 0.4 : 1;
});

var DeleteIcon = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: 2;\n  right: 50px;\n  top: 0;\n  height: 100%;\n  display: flex;\n"])));

var AddButton = (0, _styledComponents.default)('div')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 46px;\n  width: 100%;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: ease-in all 0.2s;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  ", "\n"])), _theme.colors.tertiary, function (_ref2) {
  var siblings = _ref2.siblings;
  return !siblings && (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      border-color: ", ";\n\n      &:hover {\n        border-color: #c9cfdb;\n      }\n    "])), _theme.colors.tertiary);
});
var _default = FlexibleContent;
exports.default = _default;